module.exports = __webpack_public_path__ + "src/assets/games/23/333.jpg";